<template>
  <div class="user-top-panel">
    <div class="left-side">
      <slot name="left-side"></slot>
    </div>
    <div class="right-side">
      <div class="search-field">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21">
          <path d="M8.334 2.25c-3.627 0-6.584 2.957-6.584 6.584s2.957 6.582 6.584 6.582a6.547 6.547 0 0 0 4.088-1.432l4.547 4.547a.75.75 0 0 0 1.062 0 .75.75 0 0 0 0-1.062l-4.547-4.547a6.547 6.547 0 0 0 1.432-4.088c0-3.627-2.955-6.584-6.582-6.584zm0 1.5a5.071 5.071 0 0 1 5.082 5.084 5.07 5.07 0 0 1-5.082 5.082A5.071 5.071 0 0 1 3.25 8.834 5.073 5.073 0 0 1 8.334 3.75z"/>
        </svg>
        <input type="text" placeholder="Search" v-model="search" @keypress="doSearch" @input="preSearch">
        <div class=pre-search v-if="preSearchRes !== null">
          <template v-if="preSearchRes?.[0].count > 0">
            <h3>Collections</h3>
            <ul>
              <li v-for="item in preSearchRes[0].rows" :key="item.id" @click="$router.push('/user/collections/' + item.id)">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
                  <path d="M5.334 4.584c-1.142 0-2.084.94-2.084 2.082v18.668c0 1.142.942 2.082 2.084 2.082h21.332c1.142 0 2.084-.94 2.084-2.082v-16a2.096 2.096 0 0 0-2.084-2.084H16.312l-2.058-2.057c-.39-.39-.92-.609-1.473-.609H5.334zm0 1.5h7.447a.58.58 0 0 1 .412.17l.996.996H4.75v-.584c0-.331.253-.582.584-.582zM4.75 8.75h21.916c.331 0 .584.253.584.584v16a.572.572 0 0 1-.584.582H5.334a.572.572 0 0 1-.584-.582V8.75z" color="#000" style="-inkscape-stroke:none"/>
                </svg>
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </template>
          <template v-if="preSearchRes?.[1].count > 0">
            <h3>Designs</h3>
            <ul>
              <li v-for="item in preSearchRes[1].rows" :key="item.id" @click="$router.push(designerLink(item))">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 22">
                  <path fill="#6f8789" d="M9.355 1.174a.75.75 0 0 0-.304.049l-2.043.787h-.002a.75.75 0 0 0-.063.015.75.75 0 0 0-.537.797c.14 1.365.201 2.752.201 4.155a.75.75 0 0 0 .006.101l-.017.002c.14.982.586 1.577.591 2.953a.75.75 0 0 0 0 .004c.005.63-.241 1.784-.519 2.994-.185.808-.342 1.676-.37 2.508-.062 1.699-.03 4.545-.03 4.545a.75.75 0 0 0 .75.742h7.964a.75.75 0 0 0 .75-.742s.032-2.846-.03-4.545v-.004c-.029-.84-.201-1.7-.384-2.504a.75.75 0 0 0 0-.002c-.277-1.21-.522-2.362-.517-2.992a.75.75 0 0 0 0-.004c.005-1.354.37-1.969.515-2.863a.75.75 0 0 0 .028-.193c0-1.385.062-2.775.19-4.157a.75.75 0 0 0-.495-.773l.006-.018-2.137-.806a.75.75 0 0 0-1.015.7.9.9 0 0 1-.91.895.894.894 0 0 1-.913-.894.75.75 0 0 0-.715-.75zM13 2.859l.912.346c-.14.483-.234.999-.256 1.566a8.19 8.19 0 0 0 .19 2.102c-.075.526-.538 1.482-.545 3.152-.008.973.279 2.13.556 3.34l-.002-.002c.176.773.326 1.562.348 2.225a.75.75 0 0 0 0 .004c.05 1.348.031 3.037.026 3.734H7.77c-.005-.697-.024-2.386.026-3.734a.75.75 0 0 0 0-.002c.022-.672.16-1.467.334-2.225.278-1.21.564-2.366.556-3.338-.006-1.574-.465-2.533-.585-3.05h.005c0-.03-.003-.059-.003-.088.147-.64.222-1.362.189-2.123a6.424 6.424 0 0 0-.258-1.545l.932-.358c.39.81 1.065 1.455 2.015 1.455.954 0 1.629-.648 2.018-1.459z" overflow="visible"/>
                </svg>
                <span>{{ item.title }}</span>
              </li>
            </ul>
          </template>
          <template v-if="preSearchRes?.[2].count > 0">
            <h3>Fit Models</h3>
            <ul>
              <li v-for="item in preSearchRes[2].rows" :key="item.id" @click="$router.push({ name: 'fitModelUser', params: { id: item._id } })">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
                  <path d="M16 4.584c-3.35 0-6.084 2.731-6.084 6.082 0 3.35 2.733 6.084 6.084 6.084 3.35 0 6.084-2.733 6.084-6.084 0-3.35-2.733-6.082-6.084-6.082zm0 1.5a4.571 4.571 0 0 1 4.584 4.582A4.573 4.573 0 0 1 16 15.25a4.573 4.573 0 0 1-4.584-4.584A4.572 4.572 0 0 1 16 6.084zm0 13.166c-2.344 0-4.478.625-6.072 1.688C8.334 22 7.25 23.558 7.25 25.334a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75c0-1.169.709-2.281 2.01-3.148 1.301-.868 3.166-1.436 5.24-1.436 2.074 0 3.939.568 5.24 1.436 1.301.867 2.01 1.98 2.01 3.148a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75c0-1.777-1.084-3.334-2.678-4.396-1.594-1.063-3.728-1.688-6.072-1.688z"/>
                </svg>
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </template>
          <template v-if="preSearchRes?.[3].count > 0">
            <h3>Fit Charts</h3>
            <ul>
              <li v-for="item in preSearchRes[3].rows" :key="item.id" @click="$router.push({ name: 'fitChart', params: { id: item._id } })">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 32 32">
                  <path d="M6.668 4.584c-1.142 0-2.084.94-2.084 2.082v18.668c0 1.142.942 2.082 2.084 2.082h18.666c1.142 0 2.084-.94 2.084-2.082V6.666a2.094 2.094 0 0 0-2.084-2.082zm0 1.5h8.582v5.166H6.084V6.666c0-.331.253-.582.584-.582zm10.082 0h8.584c.331 0 .584.25.584.582v4.584H16.75ZM6.084 12.75h9.166v6.5H6.084Zm10.666 0h9.168v6.5H16.75Zm-10.666 8h9.166v5.166H6.668a.572.572 0 0 1-.584-.582zm10.666 0h9.168v4.584a.572.572 0 0 1-.584.582H16.75Z"/>
                </svg>
                <span>{{ item.name }}</span>
              </li>
            </ul>
          </template>
          <RouterLink class="see-all" :to="'/user/search?q=' + search">See all</RouterLink>
        </div>
      </div>
      <ButtonSort @sort-order="sortOrder" />
      <div class="sort-field" v-if="sortOptions.length > 0">
        <ButtonSecondary
          class="small"
          :unfolded="sortDropdown"
          @click.native="sortDropdown = !sortDropdown"
        >
          {{ sort }}
        </ButtonSecondary>
        <ul v-if="sortDropdown" v-click-outside="() => sortDropdown = false">
          <template v-for="option in sortOptions">
            <li
              :key="option.value"
              v-if="option.value !== ''"
              :class="[sort === option.name ? 'selected' : '']"
              @click="sortOption(option)"
            >
              {{ option.name }}
            </li>
          </template>
        </ul>
      </div>
      <ButtonPrimary
        class="small add-desktop"
        @click.native="addNewButtonDisabled ? null : $emit('create-new')"
        v-if="addNewButton"
        :disabled="addNewButtonDisabled"
      >
        <template v-slot:icon>
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 21">
            <path d="M10 4.75a.75.75 0 0 0-.75.75v4.25H5a.75.75 0 0 0-.75.75.75.75 0 0 0 .75.75h4.25v4.25a.75.75 0 0 0 .75.75.75.75 0 0 0 .75-.75v-4.25H15a.75.75 0 0 0 .75-.75.75.75 0 0 0-.75-.75h-4.25V5.5a.75.75 0 0 0-.75-.75z"/>
          </svg>
        </template>
        <slot name="button-text">Add new</slot>
      </ButtonPrimary>
    </div>
    <div class="extra-row">
      <slot name="extra-row"></slot>
    </div>
  </div>
</template>

<script>
import { RouterLink } from 'vue-router'
import { request } from '../../api'
import ButtonPrimary from '@/components/Atoms/ButtonPrimary.vue'
import ButtonSecondary from '@/components/Atoms/ButtonSecondary.vue'
import ButtonSort from '@/components/Atoms/ButtonSort.vue'

let timeout

export default {
  name: 'TopPanel',
  components: {
    RouterLink,
    ButtonPrimary,
    ButtonSecondary,
    ButtonSort,
  },
  props: {
    sortOptions: {
      type: Array,
      default: () => [],
    },
    addNewButton: {
      type: Boolean,
      default: true,
    },
    addNewButtonDisabled: {
      type: Boolean,
      default: false,
    },
    searchQuery: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    search: '',
    sort: 'Sort by',
    sortDropdown: false,
    preSearchRes: null,
  }),
  methods: {
    preSearch (e) {
      clearTimeout(timeout)
      timeout = setTimeout(async () => {
        if (this.search === '') {
          this.preSearchRes = null
          return
        }
        try {
          const { data } = await request.get(
            '/user/search',
            { params: { q: this.search, limit: 3 } },
          )
          this.preSearchRes = data
        } catch (e) {
          console.error(e.message)
        }
      }, 250)
    },

    doSearch (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
        this.$router.push({ name: 'userSearch', query: { q: this.search } })
      }
    },
    sortOrder (order) {
      this.$emit('sort-order', order)
    },
    sortOption (option) {
      this.sort = option.name
      this.sortDropdown = false
      this.$emit('sort-option', option.value)
    },

    designerLink (design) {
      let link = '/designer/' + design.id
      if (design.mannequinId) link = `${link}/m/${design.mannequinId}`
      link = `${link}?collection=${this.collection}`
      return link
    },
  },
  mounted () {
    if (this.searchQuery.length > 0) this.search = this.searchQuery
  },
}
</script>

<style lang="scss">
.user-top-panel {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  column-gap: 40px;
  flex-wrap: wrap;

  .btn-group {
    width: auto;
    height: 40px;
    padding: 0 25px;
    box-sizing: border-box;
    border: 1px solid var(--Dividers);
    background: var(--Background);
    color: var(--Text-Text_Secondary);

    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;

    &:first-child {
      border-top-left-radius: 8px;
      border-bottom-left-radius: 8px;
      border-right-color: var(--Active-State-Strokes);
    }
    &:last-child {
      border-top-right-radius: 8px;
      border-bottom-right-radius: 8px;
      border-left: none;
    }

    &.active {
      border-color: var(--Active-State-Strokes);
      color: var(--Active-State-Strokes);
    }
  }

  .right-side {
    display: flex;
    flex-direction: row;
    position: relative;

    & * {
      border-radius: 8px;
    }

    .search-field {
      margin-right: 8px;
      max-width: 185px;
      position: relative;
      svg {
        width: 20px;
        height: 20px;
        fill: var(--primary);
        position: absolute;
        top: 10px;
        left: 12px;
      }
      input {
        width: 100%;
        height: 100%;
        border: 1px solid var(--Dividers);
        background: var(--Background);
        box-sizing: border-box;
        padding-left: 40px;
        padding-right: 12px;
        font-size: 14px;
      }

      .pre-search {
        position: absolute;
        z-index: 10;
        width: 100%;
        height: auto;
        left: 0;
        top: 60px;

        display: flex;
        flex-direction: column;
        box-sizing: border-box;
        padding: 0 16px;

        border-radius: 8px;
        border: 1px solid var(--Dividers);
        background: var(--Basic-White);
        box-shadow: 0px 6px 8px 0px rgba(146, 158, 159, 0.10);

        font-family: "DM Sans";
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;

        h3 {
          color: var(--Text-Text_Secondary);
          padding: 8px 0;
          font-size: 14px;
          line-height: normal;
        }

        ul {
          margin: 0;
          padding: 0;

          cursor: pointer;

          li {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            column-gap: 16px;

            list-style: none;
            margin: 0;
            padding: 8px 0;

            color: var(--Text-Text_Primary, #1D1F29);

            font-family: "DM Sans";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%;

            svg {
              width: 22px;
              height: 22px;
              position: static;
              flex-shrink: 0;
            }

            span {
              flex-grow: 1;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }

        .see-all {
          color: var(--Primary-Shades-Primary, #09373D);
          padding: 16px 0;
        }
      }
    }

    .button-sort {
      margin-right: 8px;
    }

    .sort-field {
      margin-right: 16px;
      position: relative;

      button {
        font-weight: 400;
      }

      ul {
        position: absolute;
        left: 0;
        top: 48px;
        z-index: 1;
        min-width: 200px;
        max-height: 160px;
        margin: 0;
        padding: 0;

        border-radius: 8px;
        border: 1px solid var(--Dividers);
        background: var(--Basic-White);
        box-shadow: 0px 6px 8px 0px rgba(146, 158, 159, 0.10);

        li {
          list-style: none;
          color: var(--Text-Text_Primary);
          font-family: "DM Sans";
          font-size: 16px;
          font-style: normal;
          font-weight: 400;
          line-height: 150%;
          padding: 8px 16px;
          cursor: pointer;
          transition: all ease-in-out 300ms;
          border-radius: 0;

          &:hover, &.selected {
            background: var(--Surface-Hover);
            color: var(--Button-States-Hover);
          }
        }
      }
    }
  }
  .extra-row {
    width: 100%;
  }
}
@media (max-width: 760px) {
  .user-top-panel {
    flex-direction: column;
    align-items: stretch;

    .left-side {
      margin-bottom: 16px;

      .btn-group {
        width: 50%;
      }
    }

    .search-field {
      max-width: none !important;
      flex-grow: 1;
    }

    .sort-field {
      margin-right: 0 !important;

      ul {
        left: auto !important;
        right: 0;
      }
    }

    .add-desktop {
      display: none;
    }
  }
}
</style>
